import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import NavigationBar from './NavigationBar';
function MainLayout() {
    return (_jsxs("div", { className: "flex min-h-screen flex-col bg-dark-700", children: [_jsx(NavigationBar, {}), _jsx("main", { className: "container-xl flex-1 py-8", children: _jsx(Outlet, {}) }), _jsx("footer", { className: "mt-auto border-t border-gray-800 bg-dark-600 py-6", children: _jsx("div", { className: "container-xl text-center text-sm text-gray-400", children: "\u00A9 2024 \u62FE\u5149\u5927\u5E08 AI\u5F71\u89C6\u521B\u4F5C\u5E73\u53F0. All rights reserved." }) })] }));
}
export default MainLayout;
